import types from './types';

const getLocationAutocompleteList = onlyBuildings => ({
  type: types.GET_LOCATION_AUTOCOMPLETE_LIST,
  params: { onlyBuildings }
});

const getBuildingSummary = (buildingNum, id) => ({
  type: types.GET_BUILDING_SUMMARY,
  params: { buildingNum, id }
});

const getWatershedIdByLocation = id => ({
  type: types.GET_WATERSHED_ID_BY_LOCATION,
  params: { id }
});

const getWatershedByLocation = id => ({
  type: types.GET_WATERSHED_BY_LOCATION,
  params: { id }
});

const getExperimentByLocation = id => ({
  type: types.GET_EXPERIMENT_BY_LOCATION,
  params: { id }
});

const saveLocation = saveDto => ({
  type: types.SAVE,
  params: { saveDto }
});

const resetBuildingSummary = () => ({
  type: types.RESET_BUILDING_SUMMARY
});

const createBuildingsQRStickersPdf = (
  gridParameters,
  selectedBuildings,
  labelsSupplier,
  labelsSupplierResultMapper,
  urlTemplateFunction,
  downloadFileName,
  errorHandler
) => ({
  type: types.CREATE_BUILDINGS_QR_STICKERS_PDF,
  params: {
    gridParameters,
    selectedBuildings,
    labelsSupplier,
    labelsSupplierResultMapper,
    urlTemplateFunction,
    downloadFileName,
    errorHandler
  }
});

const createBuildingsQRStickersPdfSuccess = () => ({
  type: types.CREATE_BUILDINGS_QR_STICKERS_PDF_SUCCESS,
});

const createBuildingsQRStickersPdfFailure = (error) => ({
  type: types.CREATE_BUILDINGS_QR_STICKERS_PDF_FAILURE,
  params: {
    error
  }
});

export default {
  getLocationAutocompleteList,
  getBuildingSummary,
  saveLocation,
  resetBuildingSummary,
  getWatershedIdByLocation,
  getWatershedByLocation,
  getExperimentByLocation,
  createBuildingsQRStickersPdf,
  createBuildingsQRStickersPdfSuccess,
  createBuildingsQRStickersPdfFailure,
};
